import styles from './AppMark.module.css';

interface Props {
  showWord?: boolean;
}

export function AppMark({ showWord = true }: Props) {
  return (
    <div className={styles.appMark}>
      <img
        src="/assets/images/logo.png"
        alt="Troy Waterfront Farmers Market"
        width={44}
        height={44}
        className={styles.logo}
        decoding="async"
        loading="eager"
      />
      {showWord && (
        <div className={styles.wordmark}>
          <span className={styles.display}>Troy Waterfront</span>
          <span className={styles.subtitle}>Farmers Market</span>
        </div>
      )}
    </div>
  );
}
